import ArticlePage from "@/pages/article/ArticlePage";
import { allArticles } from "@/mocks/articles";

export default function SafeBuyingArticle() {
  return <ArticlePage article={allArticles["allchinabuy-spreadsheet-safe-buying"]} />;
}